// Import Enums
import { ABTestStatusEnum } from 'enums';

export const ABTestStatusLabels = {
    [ABTestStatusEnum.Pending]: 'Pending',
    [ABTestStatusEnum.InProgress]: 'InProgress',
    [ABTestStatusEnum.Failed]: 'Failed',
    [ABTestStatusEnum.Completed]: 'Completed',
    [ABTestStatusEnum.Stopped]: 'Stopped',
    [ABTestStatusEnum.Calculating]: 'Calculating',
};
